/*global CustomFunctions */
import { FormulaErrorFormat } from "../../shared/types";
import { formulaErrorHandling } from "../../shared/helpers";
import { observerForCustomFunction } from "../../shared/query-client";
import { PROJECT_BY_NUMBER_BATCHER } from "../../shared/batchers";

/**
 * Gets DDB project ID.
 * @customfunction PROJECT.ID
 * @param projectNumber Project number without a dash.
 * @returns The DDB project ID.
 * @streaming
 */
export function projectId(projectNumber: string, invocation: CustomFunctions.StreamingInvocation<string>) {
  if (!/^\d{8}$/.test(projectNumber)) {
    invocation.setResult(formulaErrorHandling(FormulaErrorFormat.PROJECT_NUMBER));
    return;
  }
  observerForCustomFunction(invocation, {
    queryKey: ["project", projectNumber],
    queryFn: async () => PROJECT_BY_NUMBER_BATCHER.fetch(projectNumber),
    select: ({ project_id }) => project_id,
  });
}

CustomFunctions.associate("PROJECT.ID", projectId);